/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import Provider from './src/context/Provider';

/**
 * Called when the Gatsby browser runtime first starts.
 *
 * @returns {Promise<void>}
 */
export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    console.info('importing intersection-observer');
    await import(`intersection-observer`);
  }

  // Safely create a portal root in the browser only, and only once
  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    let portal = document.getElementById('portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.id = 'portal';
      // Ensure body exists before appending
      if (document.body) {
        document.body.appendChild(portal);
      } else {
        // Fallback: append after DOM is ready
        window.addEventListener('DOMContentLoaded', () => {
          if (!document.getElementById('portal')) {
            const p = document.createElement('div');
            p.id = 'portal';
            document.body.appendChild(p);
          }
        });
      }
    }

    // Ensure no previously-installed service worker is controlling the site
    // This prevents stale page-data/*.json and CSS from being served.
    if ('serviceWorker' in navigator) {
      try {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.unregister()));
      } catch (e) {
        console.warn('SW unregister failed', e);
      }
    }

    // Clear any runtime caches (e.g., page-data, app shell) that may hold stale assets
    if (typeof caches !== 'undefined' && caches?.keys) {
      try {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      } catch (e) {
        console.warn('Cache cleanup failed', e);
      }
    }
  }
};

export const wrapRootElement = Provider;

